export const theme = {
  colors: {
    primary: "#FBB03B",
  },

  fonts: {
    secondary: "'Averia Sans Libre', cursive",
  },

  breakpoints: {
    tablet: "768px",
  },

  pageWidth: "90%",
};
